import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import humanizeDuration from "humanize-duration";

function ScrapeRunDetail(props) {
  // Set new thresholds
  moment.relativeTimeThreshold("s", 60);
  moment.relativeTimeThreshold("ss", 3);
  moment.relativeTimeThreshold("m", 60);
  moment.relativeTimeThreshold("h", 24);
  moment.relativeTimeThreshold("d", 31);
  moment.relativeTimeThreshold("w", 4); // enables weeks
  moment.relativeTimeThreshold("M", 12);

  const { run } = props;
  let mom = moment;
  const headers = [
    "deal jacket",
    "pages in pdf",
    "pages rendered",
    "start time",
    "end time",
    "processing time",
    "errors",
  ];
  const tableHeaders = headers.map((header, i) => <th>{header}</th>);

  const tableRows = run.items.map((item, i) => (
    <tr>
      <td>
        <Link to={"/dealjacket/" + item.deal_jacket_id}>
          {item.deal_jacket_id}
        </Link>
      </td>
      <td>{item.pdf_page_count}</td>
      <td>{item.processed_page_count}</td>
      <td>{mom(item.start_time).calendar()}</td>
      <td>{item.end_time ? moment(item.end_time).calendar() : ""}</td>
      <td>
        {item.end_time
          ? moment
              .duration(new Date(item.end_time) - new Date(item.start_time))
              .humanize()
          : ""}
      </td>
      <td>{item.fault_count}</td>
    </tr>
  ));

  return (
    <>
      <table className="ingestorFormTable">
        <tr>
          <td className="formLabel"></td>
          <td className="formInfo">Scrape Run #{run.ingestion_run_id}</td>
        </tr>
        <tr>
          <td className="formLabel"></td>
          <td className="formInfo">
            Started: {moment(run.start_time).calendar()}
          </td>
        </tr>
        {run.end_time && (
          <>
            <tr>
              <td className="formLabel"></td>
              <td className="formInfo happyMessage">
                Completed: {moment(run.end_time).calendar()}
              </td>
            </tr>
            <tr>
              <td className="formLabel"></td>
              <td className="formInfo happyMessage">
                Total processing time:{" "}
                {humanizeDuration(
                  new Date(run.end_time) - new Date(run.start_time)
                )}
              </td>
            </tr>
          </>
        )}
        {!run.end_time && (
          <>
            <tr>
              <td className="formLabel"></td>
              <td className="formInfo errormessage">
                This run is still processing.
              </td>
            </tr>
          </>
        )}
        <tr>
          <td className="formLabel"></td>
          <td className="formInfo infoMessage">
            Completed {run.items.length} of {run.item_limit} items
          </td>
        </tr>
      </table>
      <br />
      <table class="paleBlueRows">
        <tbody>
          {tableHeaders}
          {tableRows}
        </tbody>
      </table>
    </>
  );
}

export { ScrapeRunDetail };
